import React, { Component } from "react";
import PropTypes from "prop-types";
import Activity from "./activity";

export default class ActivityList extends Component {
  render() {
    const {
      activities,
      showStatus,
      showCount,
      showProvider,
      showDownload,
      showVoucherActions,
    } = this.props;

    return (
      <div className="cxa-grid__wrapper apl-showcase">
        {activities.map((item, index) => (
          <Activity
            key={index}
            activity={item}
            showCount={showCount}
            showStatus={showStatus}
            showProvider={showProvider}
            showDownload={showDownload}
            showVoucherActions={showVoucherActions}
          />
        ))}
      </div>
    );
  }
}

ActivityList.propTypes = {
  activities: PropTypes.array.isRequired,
  showStatus: PropTypes.bool,
  showCount: PropTypes.bool,
  showProvider: PropTypes.bool,
  showDownload: PropTypes.bool,
  showVoucherActions: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./components/wellness/activities/activityList.jsx